var link_viewer_default = {
  "fontElementMap": "vmA48",
  "link": "_1N918",
  "linkInEditor": "_2q08Y",
  "linkInViewer": "k4zAh",
  "toolbarUrlContainer": "_6ajus",
  "toolbarUrl": "JVTOf",
  "toolbarUrlAnchor": "lHboL"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
